const MyTeamsTestIDs = {
  myTeamsHeader: 'myTeams-header',
  myTeamsBackButton: 'myTeams-back-button',
  myTeamsSearchButton: 'myTeams-search-button',
  myTeamsSearchInput: 'myTeams-search-input',
  myTeamsMyTeamsToggleButton: 'myTeams-toggle-button',
  myTeamsWatchlistToggleButton: 'myTeams-watchlist-toggle-button',

  myTeamsFilterFrontlineOnlyButton: 'myTeams-filter-frontlineOnly-button',
  myTeamsFilterRankButton: 'myTeams-filter-rank-button',
  myTeamsFilterNewCoachesButton: 'myTeams-filter-newcoaches-button',
  myTeamsFilterFIBCButton: 'myTeams-filter-fibc-button',
  myTeamsActiveFiltersElement: 'myTeams-active-filters-element',

  myTeamsCoachesNumber: 'myTeams-coaches-number',
  myTeamsFirstCoachStarButton: 'myTeams-first-coach-star-button',

  myTeamsSortButton: 'myTeams-sort-button',
  myTeamsSortOptionsGroup: 'myTeams-sort-options-group',
  myTeamsSortOptionsContainer: 'myTeams-sort-options-container',
  myTeamsSortCloseButton: 'myTeams-sort-close-button',
  myTeamsSortCloseIcon: 'myTeams-sort-close-button-icon',
  myTeamsSortByLabel: 'myTeams-sort-by-label',
  myTeamsSortingDefault: 'myTeams-sorting-default',
  myTeamsSortingFirstNameASC: 'myTeams-sort-firstname-ASC',
  MyTeamsSortingFirstNameDESC: 'myTeams-sort-firstname-DESC',
  myTeamsSortingLastNameASC: 'myTeams-sort-lastname-ASC',
  myTeamsSortingLastNameDESC: 'myTeams-sort-lastname-DESC',
  myTeamsSortingRankASC: 'myTeams-sort-rank-ASC',
  myTeamsSortingRankDESC: 'myTeams-sort-rank-DESC',
  myTeamsSortingActivationDateNewest: 'myTeams-sort-activation-date-newest',
  myTeamsSortingActivationDateOldest: 'myTeams-sort-activation-date-oldest',

  watchlistHeader: 'watchlistHeader',
  myTeamsClearButton: 'myTeams-clear-button',
  coachRow: 'record-of-coach',
  toggleDownlineCoach: 'toggle-downline-coach',
  profileImage: 'coach-profile-image',
  coachName: 'coach-name',
  toggleWatchlist: 'toggle-watchlist',
  coachDescription: 'coach-rank',
  closeToNextRank: 'close-to-next-rank',
  betweenInputMin: 'between-input-min',
  betweenInputMinMaxRange: 'between-input-min-max-range',
  betweenInputMax: 'between-input-max',
  belowInput: 'below-input',
  belowInputText: 'below-input-text',
  aboveInputText: 'above-input-text',
  aboveInput: 'above-input',
  filterByCheckbox: 'filter-by-checkbox',
  filterByFQVClientsCoaches: 'filter-by-fqv-clients-coaches',
  removeFromWatchlist: 'remove-from-watchlist',
  addToWatchlist: 'add-to-watchlist',
  arrowDropDownIcon: 'arrow-drop-down-icon',
  arrowRightIcon: 'arrow-right-icon',
  verticalLine: 'vertical-line',
  fqvDetails: 'fqv-details',
  fqvLabel: 'fqv-label',
  fqvValue: 'fqv-value',
  fqvProjectedLabel: 'fqv-projected-label',
  fqvProjectedValue: 'fqv-projected-value',
  fqvEstimatedLabel: 'fqv-estimated-label',
  fqvEstimatedValue: 'fqv-estimated-value',
  fqvData: 'fqv-data',
  newClientCountLabel: 'new-client-count-label',
  newClientCountValue: 'new-client-count-value',
  newQualifiedClientCountLabel: 'new-qualified-client-count-label',
  newQualifiedClientCountValue: 'new-qualified-client-count-value',
  newHealthCoachCountLabel: 'new-health-coach-count-label',
  newHealthCoachCountValue: 'new-health-coach-count-value',
  viewTeamButtonContainer: 'view-team-button-container',
  viewTeamButton: 'view-team-btn',
  clearAllButton: 'clear-all-button',
  applyFilterButton: 'apply-filter-button',
  sortOptionTestIDs: {
    default: 'myTeams-sorting-default',
    firstNameAZ: 'myTeams-sort-firstname-ASC',
    firstNameZA: 'myTeams-sort-firstname-DESC',
    lastNameAZ: 'myTeams-sort-lastname-ASC',
    lastNameZA: 'myTeams-sort-lastname-DESC',
    rankAsc: 'myTeams-sort-rank-ASC',
    rankDesc: 'myTeams-sort-rank-DESC',
    activationDateNew: 'myTeams-sort-activation-date-newest',
    activationDateOld: 'myTeams-sort-activation-date-oldest',
  },
};

export default MyTeamsTestIDs;
